import React, { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";

const STORAGE_KEY = "portfolio-theme";
/* 단일 다크 테마. 라이트 모드를 다시 켜려면 이 값과 index.css 의
   :root 팔레트만 바꾸면 된다. */
const DEFAULT_THEME = "dark";
const ThemeContext = createContext({ theme: "light", setTheme: () => {}, toggle: () => {} });

function storedTheme() {
	try {
		const v = localStorage.getItem(STORAGE_KEY);
		return v === "light" || v === "dark" ? v : null;
	} catch {
		return null;
	}
}

export function ThemeProvider({ children }) {
	// index.html 의 인라인 스크립트가 이미 html[data-theme] 을 찍어 뒀다면 그 값을 그대로 이어받는다
	const [theme, setThemeState] = useState(() => {
		if (typeof document !== "undefined") {
			const stamped = document.documentElement.getAttribute("data-theme");
			if (stamped === "light" || stamped === "dark") return stamped;
		}
		return storedTheme() || DEFAULT_THEME;
	});

	useEffect(() => {
		document.documentElement.setAttribute("data-theme", theme);
	}, [theme]);

	const setTheme = useCallback((next) => {
		setThemeState(next);
		try {
			localStorage.setItem(STORAGE_KEY, next);
		} catch {
			/* 저장 못 해도 이번 세션에는 반영된다 */
		}
	}, []);

	const value = useMemo(
		() => ({ theme, setTheme, toggle: () => setTheme(theme === "dark" ? "light" : "dark") }),
		[theme, setTheme]
	);

	return <ThemeContext.Provider value={value}>{children}</ThemeContext.Provider>;
}

export const useTheme = () => useContext(ThemeContext);
